import { createActions, createReducer } from 'reduxsauce'

import ItensLicitacaoDispensaService from '../../servicos/ItensLicitacaoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaItensLicitacaoDispensaInicio: [],
    buscaItensLicitacaoDispensaSucesso: ['itensLicitacaoDispensa'],
    buscaItensLicitacaoDispensaErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaItensLicitacaoDispensa = filtro => {
    return dispatch => {
        dispatch(Creators.buscaItensLicitacaoDispensaInicio())
        let serv = new ItensLicitacaoDispensaService()
        return serv
            .consultarDispensa(filtro)
            .then(response => dispatch(Creators.buscaItensLicitacaoDispensaSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaItensLicitacaoDispensaErro(error)))
    }
}

const buscaItensLicitacaoDispensaInicio = (state = INITIAL_STATE, action) => {
    return { ...state, carregando: true, erro: null }
}

const buscaItensLicitacaoDispensaErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaItensLicitacaoDispensaSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.itensLicitacaoDispensa, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_ITENS_LICITACAO_DISPENSA_INICIO]: buscaItensLicitacaoDispensaInicio,
    [Types.BUSCA_ITENS_LICITACAO_DISPENSA_ERRO]: buscaItensLicitacaoDispensaErro,
    [Types.BUSCA_ITENS_LICITACAO_DISPENSA_SUCESSO]: buscaItensLicitacaoDispensaSucesso,
})
